<template>
  <section class="descrGus">
    <div class="container">
      <p class="descrGeralGus inter-regular">{{ $t('homePage.descricaoGus1') }}{{ idadeAtual }}{{ $t('homePage.descricaoGus1eMeio') }}</p>
      <p class="descrGeralGus inter-regular">{{ $t('homePage.descricaoGus2') }}</p>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const idadeAtual = computed(() => {
  const hoje = new Date()
  const anoNascimento = 2002
  const mesNascimento = 6
  const diaNascimento = 23

  let idade = hoje.getFullYear() - anoNascimento
  const aindaNaoFezAniversario =
    hoje.getMonth() < mesNascimento ||
    (hoje.getMonth() === mesNascimento && hoje.getDate() < diaNascimento)

  if (aindaNaoFezAniversario) idade -= 1

  return idade
})
</script>

<style scoped>
.descrGus {
  min-height: 0;
  background-image: url('@/assets/fundo-contratempo-mmbranco.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
}

.descrGeralGus {
  color: var(--color-bg-dark);
  font-size: 20px;
  font-weight: 300;
  line-height: 1.5;
  margin: 0;
  text-align: justify;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 24px;
  text-align: left;
}

</style>
